/**
 * @internal
 */
export var Status;
(function (Status_1) {
    class Status {
        _result;
        constructor(result) {
            this._result = result;
        }
        get result() {
            return this._result;
        }
    }
    class Created extends Status {
        static of(result) {
            return new Created(result);
        }
        constructor(result) {
            super(result);
        }
        get status() {
            return "created";
        }
    }
    Status_1.Created = Created;
    Status_1.created = Created.of;
    class Updated extends Status {
        static of(result) {
            return new Updated(result);
        }
        constructor(result) {
            super(result);
        }
        get status() {
            return "updated";
        }
    }
    Status_1.Updated = Updated;
    Status_1.updated = Updated.of;
    class Deleted extends Status {
        static of(result) {
            return new Deleted(result);
        }
        constructor(result) {
            super(result);
        }
        get status() {
            return "deleted";
        }
    }
    Status_1.Deleted = Deleted;
    Status_1.deleted = Deleted.of;
    class Unchanged extends Status {
        static of(result) {
            return new Unchanged(result);
        }
        constructor(result) {
            super(result);
        }
        get status() {
            return "unchanged";
        }
    }
    Status_1.Unchanged = Unchanged;
    Status_1.unchanged = Unchanged.of;
})(Status || (Status = {}));
//# sourceMappingURL=status.js.map